import { render, staticRenderFns } from "./Linkarea.vue?vue&type=template&id=2121b17a&scoped=true&"
import script from "./Linkarea.vue?vue&type=script&lang=js&"
export * from "./Linkarea.vue?vue&type=script&lang=js&"
import style0 from "./Linkarea.vue?vue&type=style&index=0&id=2121b17a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2121b17a",
  null
  
)

export default component.exports